'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecipientReportData = exports.getReportData = undefined;

var _reselect = require('reselect');

var _reports = require('helpers/reports');

var _getReportData = function _getReportData(state) {
  return state.report.reportData || {};
};
var _getRecipientReportData = function _getRecipientReportData(state) {
  return state.report.recipientReportData || {};
};

var getReportData = exports.getReportData = (0, _reselect.createSelector)([_getReportData], function (data) {
  return (0, _reports.processReport)(data);
});

var getRecipientReportData = exports.getRecipientReportData = (0, _reselect.createSelector)([_getRecipientReportData], function (data) {
  return (0, _reports.processRecipientReport)(data);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/report.js
// module id = 874
// module chunks = 1